// extracted by mini-css-extract-plugin
export default {"wrapper":"JVL7j","connectBtn":"qJxua","changeTariffBtn":"Epjtj","col":"IhZzM","allRow":"EpD1x"};